import { useContext } from 'react'
import { useQuery } from 'react-query'
import { apiGet } from 'api'
import AuthContext from 'context/auth-context'

const getUserDataAccesses = async (token, params) => {
  const url = `employees/${params.employee_id}/data_access`
  const data = await apiGet({ url, params, token })
  return data
}

export function useUserDataAccesses({ params, options }) {
  const token = useContext(AuthContext)
  const queryFn = () => getUserDataAccesses(token, params)
  const queryKey = ['user-data-access', params]
  return useQuery(queryKey, queryFn, { ...options })
}
